import { UtmTags } from '../entities';

export const POSSIBLE_UTM_TAGS: Array<keyof UtmTags> = [
  'utm_source',
  'utm_medium',
  'utm_content',
  'utm_term',
  'utm_campaign_id',
  'utm_campaignid',
  'utm_campaign',
  'utm_adset_id',
  'utm_adsetid',
  'utm_adset',
  'utm_ad_id',
  'utm_adid',
  'utm_ad',
  'gclid',
  'gbraid',
  'delivery_id',
  'action_id',
  'fbp',
  'fbc',
  'fbclid',
  'ga',
  'everflow_transaction_id',
  'utm_source_retention',
  'utm_adset_name',
  'utm_placement',
  'utm_ad_name',
  'ttclid',
  'quizz',
  'oid',
  '_ef_transaction_id',
  'fb_test_event_code',
  'seo_channel',
  'seo_landing_page',
  'seo_referrer',
];

export const UTM_TAGS_COOKIE_LIFETIME_IN_DAYS = 5 / 24;
